import * as React from "react";
import { Component } from "react";
import { SketchPicker } from "react-color";
import { EditableInput } from "react-color/lib/components/common";
import * as Color from "shared/util/Color";

interface ColorPickerProps {
    color: Color.RGBA;
    showInput?: boolean;
    onChange(color: Color.RGBA): void;
}
interface ColorPickerState {
    isPickerVisible: boolean;
}

class ColorPicker extends Component<ColorPickerProps, ColorPickerState> {
    constructor(props: ColorPickerProps) {
        super(props);
        this.state = {
            isPickerVisible: false,
        };
    }

    handleClick = () => {
        this.setState({ isPickerVisible: !this.state.isPickerVisible });
    }

    handleClose = () => {
        this.setState({ isPickerVisible: false });
    }

    handleInputChange = (color: string) => {
        if(Color.isValidHex(color, true)) {
            const rgbaStyle = Color.hexToRgba(color, "1");
            const rgbaObject = Color.parseRgba(rgbaStyle);
            this.props.onChange(rgbaObject);
        }
    }

    handlePickerChange = (color) => {
        this.props.onChange(color.rgb);
    }

    render() {
        const {color, showInput} = this.props;
        const {isPickerVisible} = this.state;
        const hexColor = Color.formatRgbaToHex(color).toUpperCase();

        const swatchInnerStyle: React.CSSProperties = {
            width: "36px",
            height: "14px",
            borderRadius: "2px",
            background: Color.formatRgbaToStyle(color),
        };

        const swatchOuterStyle: React.CSSProperties = {
            padding: "5px",
            background: "#fff",
            borderRadius: "1px",
            boxShadow: "0 0 0 1px rgba(0,0,0,.1)",
            display: "inline-block",
            cursor: "pointer",
        };

        const pickerPopoverStyle: React.CSSProperties = {
            position: "absolute",
            left: "-20px",
            top: "30px",
            zIndex: 2,
            // zmags style overrides
            lineHeight: 1,

        };

        const pickerPopoverCoverStyle: React.CSSProperties = {
            position: "fixed",
            top: "0px",
            right: "0px",
            bottom: "0px",
            left: "0px",
        };

        return (
            <div>
                <div>
                    <label className="pull-left">
                        {
                            !!showInput &&
                            <EditableInput value={hexColor} onChange={this.handleInputChange} />
                        }
                        <div onClick={this.handleClick}>
                            {
                                !showInput && (<span style={{padding: "0 5px", verticalAlign: "top"}}>{hexColor}</span>)
                            }
                            <div style={swatchOuterStyle}>
                                <div style={swatchInnerStyle} />
                            </div>
                        </div>
                    </label>
                </div>
                {
                    isPickerVisible &&
                    (<div style={pickerPopoverStyle}>
                        <div style={pickerPopoverCoverStyle} onClick={this.handleClose}/>
                            <SketchPicker
                                color={color}
                                onChange={this.handlePickerChange}
                                disableAlpha={true}
                                presetColors={[]}
                            />
                    </div>)
                }

            </div>
        );
    }
}

export {
    ColorPicker as default,
    ColorPicker,
};



// WEBPACK FOOTER //
// ./src/shared/ui/common/ColorPicker.tsx